import { render, staticRenderFns } from "./Incubator.vue?vue&type=template&id=5474f7de&scoped=true&"
import script from "./Incubator.vue?vue&type=script&lang=js&"
export * from "./Incubator.vue?vue&type=script&lang=js&"
import style0 from "./Incubator.vue?vue&type=style&index=0&id=5474f7de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474f7de",
  null
  
)

export default component.exports